import { styled } from "@mui/material";

export const Styled = {
    Form: styled("form")`
        padding: 54px;
        border-radius: 8px;
        background: ${({ theme }) => theme.palette.secondary.main};
    `,
    Inputs: styled("div")`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin: 16px 0 24px 0;
        width: 330px;
        ${props => props.theme.breakpoints.down("md")} {
            width: 300px;
            margin: 15px 0px;
        }
    `,
};
